module.exports = __webpack_public_path__ + "img/numall.1630993415105.png";